module.exports = __webpack_public_path__ + "static/data_process-4a773a42df82521e4e44306095cc0ca6.svg";